import { loanApplicationNonBorrowersApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_APPPLICATION_NON_BORROWERS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/nonBorrowers`,
  {
    GET_NON_BORROWERS_TABLE_DATA: 'GET_NON_BORROWERS_TABLE_DATA',
  },
);

export const getNonBorrowersTableDataAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanApplicationNonBorrowersApi.getNonBorrowersTableData(params);

  return dispatch({
    type: LOAN_APPPLICATION_NON_BORROWERS_ACTION_TYPE.GET_NON_BORROWERS_TABLE_DATA,
    payload: data,
  });
});

export const getNonBorrowersDataAction = catchAsyncActionError(params => async () => {
  const { data } = await loanApplicationNonBorrowersApi.getNonBorrowersData(params);

  return data;
});
